// TYPES & ACTIONS
export const SET_APPLICATION_ROLES = 'SET_APPLICATION_ROLES'
export const setApplicationRoles = roles => ({
  type: SET_APPLICATION_ROLES,
  payload: roles,
})

// SELECTORS
export const selectApplicationRoles = state => state.application.roles

// STATE
export const INITIAL_STATE = []

// REDUCER
const roles = (state = INITIAL_STATE, { type, payload } = {}) =>
  ({
    [SET_APPLICATION_ROLES]: (currentState, newPayload) => [...newPayload],
  }[type]?.(state, payload) || state)

export default roles
